import adminReducer from 'admin/services/reducer'
import authReducer from 'services/auth/reducer'
import composerReducer from 'services/compose'
import contentReducer from 'services/content'
import contentPopupReducer from 'services/contentPopup'
import contentPreviewReducer from 'services/contentPreview'
import destinationsReducer from 'services/destinations'
import externalServicesReducer from 'services/external'
import { listsReducer } from 'services/lists'
import planReducer from 'services/plan'
import postReducer from 'services/post'
import productReducer from 'services/product'
import searchReducer from 'services/search/reducer'
import settingsReducer from 'services/settings'
import snackbarReducer from 'services/snackbar/reducer'
import appUIReducer from 'services/ui'
import uploadsReducer from 'services/uploads'
import userReducer from 'services/users'
import hydrationReducer from './hydration'
import versionReducer from './version'

export default {
  content: contentReducer,
  composer: composerReducer,
  destinations: destinationsReducer,
  lists: listsReducer,
  snackbar: snackbarReducer,
  user: userReducer,
  plan: planReducer,
  post: postReducer,
  contentPreview: contentPreviewReducer,
  external: externalServicesReducer,
  auth: authReducer,
  settings: settingsReducer,
  contentPopup: contentPopupReducer,
  uploads: uploadsReducer,
  search: searchReducer,
  hydration: hydrationReducer,
  version: versionReducer,
  admin: adminReducer,
  ui: appUIReducer,
  product: productReducer
}
